// extracted by mini-css-extract-plugin
export default {"root":"urT2WH","post-page--split":"jppFz_","postPageSplit":"jppFz_"};